<template>
  <ReviewsResourcesBadges
    subject="product"
    :entity-id="product.id"
    :slug="product.slug"
    :title="product.title"
    :assigned-badges="product.assignedBadges"
    :expired-assigned-badges="product.expiredAssignedBadges"
    :is-fenced="!product.configFlags.badgesManagementAllowed"
  />
</template>
<script setup lang="ts">
import type { ProductData } from '@/gql/reviews'

import ReviewsResourcesBadges from '../../ReviewsCommon/Resources/ReviewsResourcesBadges.vue'

defineProps<{ product: ProductData }>()
</script>
